import { PhoneTonePlayer } from 'play-dtmf';
import { createContext } from "react";

interface DtmfInterface {
  dtmfPlayer: PhoneTonePlayer | null
}

export const DtmfContext = createContext<DtmfInterface | null>(null);
